import SiteButton from '@/components/atoms/SiteButton'
import heroBackgroundDesktop from '@/assets/illustrations/hero background desktop.svg'
import heroBackgroundMobile from '@/assets/illustrations/hero background mobile.svg'

// Copy source: content/unimo-messaging.md, "Hero phrase — industry agnostic"
export function Hero() {
    return (
        <section className="relative isolate overflow-hidden rounded-site-panel">
            <img
                src={heroBackgroundDesktop}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 hidden h-full w-full object-cover md:block"
            />
            <img
                src={heroBackgroundMobile}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover md:hidden"
            />
            <div className="relative flex flex-col px-8 py-12 md:aspect-[1280/527] md:justify-center lg:px-16 lg:py-12">
                <h1 className="max-w-2xl text-4xl font-medium text-white lg:text-6xl">
                    Model, watch, and report on your site.
                </h1>
                <p className="mt-4 max-w-xl text-lg font-light text-white lg:mt-6 lg:text-xl">
                    No data engineers, no analysts. Just ask.
                </p>
                <SiteButton href="/contact?topic=pricing" className="mt-6 w-fit lg:mt-8">
                    Contact us
                </SiteButton>
            </div>
        </section>
    )
}

export default Hero
